import React, { useContext, useEffect, useState } from "react";
import { Button, Form, Modal } from "react-bootstrap";
import Modal_Heading from "../../Common_Component/Modal_Heading/Modal_Heading";
import Edit_User_Modal_Frame from "../../Common_Component/Common_Modal/Edit_User_Modal/Edit_User_Modal_Frame/Edit_User_Modal_Frame";
import { Create } from "../../../utils/apis/master/city/city";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import { HTTPS } from "../../../utils/common";
import { Country, State } from "../../../utils/apis/common/index";
import { Context } from "../../../utils/context";
import Select from "react-select";
import ModalSave from "../../Common_Component/Common_Modal/Successfull_Modal/ModelSave";
function Add(props) {
  const { UnauthorizedLogOut, Select2Data } = useContext(Context);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setError,
    control,
    setValue,
  } = useForm();

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);

  const GetAllCountry = async () => {
    const response = await Country();
    if (response?.data?.success) {
      setCountries(await Select2Data(response?.data?.data, "country_id"));
    }
  };

  const GetAllStates = async (id) => {
    const response = await State(id);

    if (response?.data?.success) {
      setStates(await Select2Data(response?.data?.data, "state_id"));
    }
  };

  useEffect(() => {
    GetAllCountry();
  }, []);

  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append("country_id", data?.country_id?.value);
      DataToSend.append("state_id", data?.state_id?.value);
      DataToSend.append("name", data?.name);
      const response = await Create(DataToSend);

      if (response?.data?.success) {
        await setShowModal({
          code: response.data.code,
          message: response.data.data,
        });
        setTimeout(() => {
          setShowModal(0);
          props.onHide();
          reset();
        }, 1000);
      } else {
        setError("name", {
          message: response?.data?.errors?.name?.msg,
        });
      }
    } catch (error) {
      setError("name", {
        type: "manual", // Optional but helps to indicate it's a manual error
        message: error?.response?.data?.errors,
      });
      await UnauthorizedLogOut(error);

      console.error(error.message);
    }
  };

  return (
    <>
      <section>
        <Modal
          {...props}
          className="Edit_User_Modal modal_holder"
          size="md"
          aria-labelledby="contained-modal-title-vcenter"
          centered>
          <Modal_Heading modalHeading={"Add City"} />
          <div className="modal-body-holder">
            {/* <Edit_User_Modal_Frame /> */}
            <Modal.Body>
              <div className="main-form-holder">
                <Form className="form-holder" onSubmit={handleSubmit(onSubmit)}>
                  <div className="row">
                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>Country*</Form.Label>
                        <Controller
                          name="country_id" // name of the field
                          {...register("country_id", {
                            required: "Select Country",
                          })}
                          control={control}
                          render={({ field }) => (
                            <Select
                              styles={{
                                control: (baseStyles) => ({
                                  ...baseStyles,
                                  borderColor: errors.country_id
                                    ? "red"
                                    : baseStyles,
                                }),
                              }}
                              {...field}
                              options={countries}
                              onChange={(selectedOption) => {
                                field.onChange(selectedOption.value); // Update Controller's value
                                GetAllStates(selectedOption.value);
                                setValue("country_id", selectedOption);
                                setValue("state_id", null);
                              }}
                            />
                          )}
                        />
                        {errors.country_id && (
                          <span className="text-danger">
                            {errors.country_id.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>

                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>State*</Form.Label>
                        <Controller
                          name="state_id" // name of the field
                          {...register("state_id", {
                            required: "Select State",
                          })}
                          control={control}
                          render={({ field }) => (
                            <Select
                              styles={{
                                control: (baseStyles) => ({
                                  ...baseStyles,
                                  borderColor: errors.state_id
                                    ? "red"
                                    : baseStyles,
                                }),
                              }}
                              {...field}
                              options={states}
                            />
                          )}
                        />

                        {errors.state_id && (
                          <span className="text-danger">
                            {errors.state_id.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                    <div className="col-md-12 col-sm-12 mt-3">
                      <Form.Group
                        className="form-field"
                        controlId="formBasicEmail">
                        <Form.Label>City Name*</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          placeholder="City"
                          className={classNames("", {
                            "is-invalid": errors?.name,
                          })}
                          {...register("name", {
                            required: "City is required",
                            maxLength: {
                              value: 100,
                              message: "Name cannot exceed 100 characters",
                            },
                          })}
                        />
                        {errors.name && (
                          <span className="text-danger">
                            {errors.name.message}
                          </span>
                        )}
                      </Form.Group>
                    </div>
                  </div>
                </Form>

                <div className="modal-footer-holder">
                  <div className="d-flex justify-content-center align-items-center">
                    <Button
                      className="search-btn mx-2"
                      onClick={() => {
                        props.onHide();
                        reset();
                      }}>
                      Cancel
                    </Button>

                    <Button
                      className="reset-btn mx-2"
                      type="button"
                      onClick={handleSubmit(onSubmit)}>
                      Submit
                    </Button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </div>
        </Modal>
        <ModalSave
          message={showModal.message}
          showErrorModal={showModal.code ? true : false}
        />
      </section>
    </>
  );
}

export default Add;
